"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var view_student_html_1 = __importDefault(require("./view-student.html"));
var view_student_controller_1 = __importDefault(require("./view-student.controller"));
var time_1 = require("../../../common/helpers/time");
function getStudent(UsersModel, $stateParams) {
    return UsersModel.getStudentByID($stateParams.studentId).then(function (response) {
        response.usermeta.certificate_issue_date = (0, time_1.dateOrEmptyString)(response.usermeta.certificate_issue_date);
        response.usermeta.drive_deadline = (0, time_1.dateOrEmptyString)(response.usermeta.drive_deadline);
        response.usermeta.start_date = (0, time_1.dateOrEmptyString)(response.usermeta.start_date);
        if (response.usermeta.permit) {
            response.usermeta.permit.issuedate = (0, time_1.dateOrEmptyString)(response.usermeta.permit.permit_issue_date);
            response.usermeta.permit.expirationdate = (0, time_1.dateOrEmptyString)(response.usermeta.permit.permit_expiration_date);
        }
        /* @ts-ignore */
        response.school.address = JSON.parse(response.school.address);
        return response;
    });
}
getStudent.$inject = ["UsersModel", "$stateParams"];
function getUsermeta(StudentUsermetaModel, $stateParams) {
    return StudentUsermetaModel.index($stateParams.studentId).then(function (response) {
        return response;
    });
}
getUsermeta.$inject = ["StudentUsermetaModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.student", {
        url: "/student/:studentId",
        template: view_student_html_1.default,
        controller: view_student_controller_1.default,
        controllerAs: "vm",
        resolve: {
            student: getStudent,
            usermeta: getUsermeta
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.student", [])
    .config(config)
    .controller("InstructorStudentController", view_student_controller_1.default);
